<div class="mnt app-dialog mnt-det">

  <!-- ==================== Encabezado ==================== -->
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="mnt-cat mnt-cat--det" aria-hidden="true" *ngIf="s">
        <span class="material-icons">{{ categoria?.icono || 'handyman' }}</span>
      </span>
      <div class="mnt-det__titulos">
        <p class="app-dialog__eyebrow">Mantenimiento<span *ngIf="s"> · {{ s.folio }}</span></p>
        <h2>
          {{ s ? (categoria?.texto || s.categoria || 'Solicitud') : 'Solicitud' }}
          <span class="mnt-estatus" *ngIf="s" [ngClass]="estatus.clase">
            <span class="material-icons" aria-hidden="true">{{ estatus.icono }}</span>{{ estatus.texto }}
          </span>
        </h2>
        <p *ngIf="s">
          Pidió <b>{{ s.solicitante }}</b> el {{ cuando(s.fechaSolicitud) }}
          <ng-container *ngIf="s.responsable"> · Atiende <b>{{ s.responsable }}</b></ng-container>
        </p>
      </div>
    </div>
    <button type="button" class="app-dialog__close mnt-det__cerrar" (click)="cerrar()" aria-label="Cerrar" title="Cerrar">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <!-- ==================== Contenido ==================== -->
  <div class="app-dialog__content mnt-det__contenido">

    <div class="mnt-det__estado" *ngIf="cargando && !s">
      <span class="material-icons" aria-hidden="true">hourglass_top</span> Abriendo…
    </div>
    <div class="mnt-det__estado mnt-det__estado--error" *ngIf="error && !s" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span> {{ error }}
    </div>

    <ng-container *ngIf="s">

      <!-- ===== Lo que toca hacer, arriba de todo ===== -->

      <!-- Quien la pidió, cuando ya se resolvió: su visto bueno. -->
      <section class="mnt-llamado es-resuelta" *ngIf="puedeConfirmar">
        <span class="material-icons mnt-llamado__icono" aria-hidden="true">task_alt</span>
        <div class="mnt-llamado__txt">
          <b>¿Quedó bien?</b>
          <span>
            {{ s.responsable || 'Mantenimiento' }} la dio por resuelta. Confírmalo o di qué sigue mal.
            <ng-container *ngIf="cierraEl">Si no contestas, se cierra sola el {{ cierraEl }}.</ng-container>
          </span>
        </div>
        <div class="mnt-llamado__btns">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  [disabled]="trabajando" (click)="reabrir()">
            <span class="material-icons" aria-hidden="true">replay</span>Sigue mal
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                  [disabled]="trabajando" (click)="confirmar()">
            <span class="material-icons" aria-hidden="true">thumb_up</span>Sí, quedó bien
          </button>
        </div>
      </section>

      <!-- Quien atiende, cuando nadie la ha tomado. -->
      <section class="mnt-llamado es-nueva" *ngIf="puedeTomar">
        <span class="material-icons mnt-llamado__icono" aria-hidden="true">front_hand</span>
        <div class="mnt-llamado__txt">
          <b>{{ huerfana ? (s.responsable || 'Quien la tenía') + ' ya no atiende mantenimiento' : 'Nadie la ha tomado' }}</b>
          <span>{{ huerfana ? 'Tómala para seguirla tú, o pásala a alguien más.' : 'Al tomarla pasa a «En atención» y se le avisa a quien la pidió.' }}</span>
        </div>
        <div class="mnt-llamado__btns">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  *ngIf="puedeReasignar" [disabled]="trabajando" (click)="reasignar()">
            <span class="material-icons" aria-hidden="true">forward</span>Asignar a otro
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                  [disabled]="trabajando" (click)="tomar()">
            <span class="material-icons" aria-hidden="true">pan_tool_alt</span>Tomarla
          </button>
        </div>
      </section>

      <!-- Quien la atiende: moverla. -->
      <section class="mnt-acciones" *ngIf="puedeMover" aria-label="Mover la solicitud">
        <span class="mnt-acciones__lbl">La atiendes tú</span>
        <button type="button" class="mnt-accion" *ngIf="s.estatus !== 'EN_ESPERA'"
                [disabled]="trabajando" (click)="mover('EN_ESPERA')">
          <span class="material-icons" aria-hidden="true">hourglass_top</span>Poner en espera
        </button>
        <button type="button" class="mnt-accion" *ngIf="s.estatus === 'EN_ESPERA'"
                [disabled]="trabajando" (click)="mover('EN_ATENCION')">
          <span class="material-icons" aria-hidden="true">play_arrow</span>Retomar
        </button>
        <button type="button" class="mnt-accion es-ok"
                [disabled]="trabajando" (click)="mover('RESUELTA')">
          <span class="material-icons" aria-hidden="true">task_alt</span>Dar por resuelta
        </button>
        <button type="button" class="mnt-accion" *ngIf="puedeReasignar"
                [disabled]="trabajando" (click)="reasignar()">
          <span class="material-icons" aria-hidden="true">forward</span>Pasar a otro
        </button>
        <button type="button" class="mnt-accion es-no"
                [disabled]="trabajando" (click)="mover('CANCELADA')">
          <span class="material-icons" aria-hidden="true">block</span>No procede
        </button>
      </section>

      <div class="mnt-det__rejilla">

        <!-- ===== Izquierda: la solicitud ===== -->
        <div class="mnt-det__col">
          <dl class="mnt-datos">
            <div *ngIf="s.ubicacion">
              <dt>Dónde</dt>
              <dd><span class="material-icons" aria-hidden="true">place</span>{{ s.ubicacion }}</dd>
            </div>
            <div>
              <dt>Urgencia</dt>
              <dd><span class="mnt-urgencia" [ngClass]="'es-' + (s.urgencia || '').toLowerCase()">{{ urgencia?.texto || s.urgencia }}</span></dd>
            </div>
            <div *ngIf="s.telefonoContacto">
              <dt>Teléfono</dt>
              <dd><span class="material-icons" aria-hidden="true">call</span>{{ s.telefonoContacto }}</dd>
            </div>
            <div *ngIf="s.fechaResuelta">
              <dt>Resuelta</dt>
              <dd>{{ cuando(s.fechaResuelta) }}</dd>
            </div>
            <div *ngIf="s.fechaCierre">
              <dt>Cerrada</dt>
              <dd>{{ cuando(s.fechaCierre) }}<span class="mnt-datos__nota" *ngIf="s.cierreAutomatico"> (sola)</span></dd>
            </div>
            <div *ngIf="s.reaperturas">
              <dt>Reabierta</dt>
              <dd>{{ s.reaperturas }} {{ s.reaperturas === 1 ? 'vez' : 'veces' }}</dd>
            </div>
          </dl>

          <h3 class="mnt-det__sub">Asunto</h3>
          <p class="mnt-det__desc">{{ s.descripcion }}</p>

          <!-- Fotos: las de quien pidió y las de quien atiende, por separado. -->
          <div class="mnt-det__fotos-cab">
            <h3 class="mnt-det__sub">Fotos</h3>
            <label class="mnt-det__subir" *ngIf="puedeSubirFoto" [class.es-deshabilitado]="trabajando">
              <span class="material-icons" aria-hidden="true">add_a_photo</span>
              {{ esResponsable && puedeAtender ? 'Subir cómo quedó' : 'Agregar foto' }}
              <input type="file" multiple [attr.accept]="ACEPTADAS" (change)="subirFotos($event)" [disabled]="trabajando" hidden />
            </label>
          </div>

          <p class="mnt-vacio mnt-det__nada" *ngIf="!fotos.length">Sin fotos.</p>

          <ng-container *ngFor="let grupo of grupos">
            <div class="mnt-det__grupo" *ngIf="grupo.lista.length">
              <span class="mnt-det__grupo-tit">{{ grupo.titulo }}</span>
              <div class="mnt-galeria">
                <div class="mnt-mini" *ngFor="let f of grupo.lista; trackBy: trackFoto">
                  <button type="button" class="mnt-mini__ver" (click)="verGrande(f)"
                          [attr.aria-label]="'Ver ' + (f.nombreArchivo || 'foto')">
                    <img *ngIf="vistas.get(f.idFoto!) as url; else cargandoFoto" [src]="url" [alt]="f.nombreArchivo || ''" />
                    <ng-template #cargandoFoto><span class="material-icons mnt-mini__carga" aria-hidden="true">image</span></ng-template>
                  </button>
                  <button type="button" class="mnt-mini__x" *ngIf="puedeQuitar(f)" [disabled]="trabajando"
                          title="Quitar" [attr.aria-label]="'Quitar ' + (f.nombreArchivo || 'foto')"
                          (click)="quitarFoto(f, $event)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- ===== Derecha: la historia y los comentarios ===== -->
        <div class="mnt-det__col mnt-det__col--historia">
          <h3 class="mnt-det__sub">Historia</h3>
          <ol class="mnt-hist">
            <li class="mnt-hist__item" *ngFor="let h of historial; trackBy: trackHist" [ngClass]="claseHistoria(h)">
              <span class="mnt-hist__punto" aria-hidden="true"><span class="material-icons">{{ iconoHistoria(h) }}</span></span>
              <div class="mnt-hist__cuerpo">
                <div class="mnt-hist__cab">
                  <b>{{ h.usuario || (h.idUsuario == null ? 'El sistema' : '—') }}</b>
                  <time>{{ cuando(h.fecha) }}</time>
                </div>
                <span class="mnt-hist__cambio" *ngIf="h.estatusNuevo && h.accion !== 'ALTA'">
                  <ng-container *ngIf="h.estatusAnterior">{{ etiquetaEstatus(h.estatusAnterior) }}
                    <span class="material-icons" aria-hidden="true">arrow_forward</span></ng-container>
                  {{ etiquetaEstatus(h.estatusNuevo) }}
                </span>
                <p class="mnt-hist__txt" *ngIf="h.comentario">{{ h.comentario }}</p>
              </div>
            </li>
          </ol>

          <div class="mnt-comentar" *ngIf="puedeComentar">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Escribe un comentario</mat-label>
              <textarea matInput aria-label="Escribe un comentario" rows="2" maxlength="2000" [(ngModel)]="comentario" name="comentario"
                        (keydown.control.enter)="comentar()"></textarea>
            </mat-form-field>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    [disabled]="trabajando || !comentario.trim()" (click)="comentar()">
              <span class="material-icons" aria-hidden="true">send</span>Comentar
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- ==================== Pie ==================== -->
  <footer class="app-dialog__footer mnt-det__pie">
    <button type="button" class="mnt-det__retirar" *ngIf="puedeCancelar" [disabled]="trabajando" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">undo</span>Retirar solicitud
    </button>
    <span class="mnt-det__espacio"></span>
    <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cerrar()">Cerrar</button>
  </footer>

  <!-- La foto en grande, encima del diálogo. -->
  <div class="mnt-visor" *ngIf="grande" (click)="grande = null" role="dialog" aria-label="Foto">
    <img [src]="vistas.get(grande.idFoto!)" [alt]="grande.nombreArchivo || ''" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" />
    <span class="mnt-visor__pie">{{ grande.nombreArchivo }} · {{ grande.usuario }} · {{ cuando(grande.fecha) }}</span>
    <button type="button" class="mnt-visor__x" (click)="grande = null" aria-label="Cerrar la foto">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>
</div>
